export const GRAPHQL_API_PATHNAME = '/poker/activegames/v1/graphql';
export const ACTIVE_GAMES_LOCAL_STORAGE_KEY = 'currentOpenActiveGames';
